module.exports = __webpack_public_path__ + "img/about.d65eeaf6.png";